export const AGGREGATION_TYPES = [
  { value: "terms", label: "Group by Category" },
  { value: "dateHistogram", label: "Over Time" },
  { value: "count", label: "Total Count" },
  { value: "average", label: "Average" },
] as const;

export type AggregationType = (typeof AGGREGATION_TYPES)[number]["value"];

/** Fields available for each aggregation type */
export const FIELDS_BY_AGGREGATION: Record<AggregationType, { value: string; label: string }[]> = {
  terms: [
    { value: "interactionType", label: "Interaction Type" },
    { value: "agentName", label: "Agent Name" },
    { value: "direction", label: "Direction" },
    { value: "tags", label: "Tags" },
    { value: "skill", label: "Skill" },
    { value: "group", label: "Group" },
    { value: "phoneNumber", label: "Phone Number" },
    { value: "dnis", label: "DNIS" },
  ],
  dateHistogram: [
    { value: "startTime", label: "Start Time" },
  ],
  count: [],
  average: [
    { value: "durationMs", label: "Duration" },
  ],
};

/** Chart types valid for each aggregation type */
export const CHART_TYPES_BY_AGGREGATION: Record<AggregationType, string[]> = {
  terms: ["bar", "pie"],
  dateHistogram: ["bar", "line"],
  count: ["kpi"],
  average: ["kpi"],
};

export const CHART_TYPE_OPTIONS = [
  { value: "bar", label: "Bar Chart", icon: "BarChart" },
  { value: "pie", label: "Pie Chart", icon: "PieChart" },
  { value: "line", label: "Line Chart", icon: "ShowChart" },
  { value: "kpi", label: "KPI", icon: "Speed" },
] as const;

export const INTERVAL_OPTIONS = [
  { value: "1d", label: "Daily" },
  { value: "1M", label: "Monthly" },
  { value: "1y", label: "Yearly" },
] as const;

/** Default values for a new widget */
export const DEFAULT_WIDGET_BUILDER_VALUES = {
  title: "New Widget",
  chartType: "bar",
  aggregationType: "terms" as AggregationType,
  field: "interactionType",
  interval: "1M",
  size: 10,
};
